export const TEST_ID = 'accountIcon';
